// src/data/doctorsData.js
import DrRishiImage from "../images/drrishi.webp";
import DrPritiImage from "../images/drpriti.webp";
import DrChiragImage from "../images/drchirag.webp";
import DrDeepakImage from "../images/drdeepak.webp";
import DrPankajImage from "../images/drpankaj.webp";

export const doctors = [
  {
    sl: 1,
    name: "Dr. Rishi Kumar Agrawal",
    designation: "General Surgeon",
    qualification: "MBBS MS, FIAGES, FMAS, FALS",
    council: "CGMC",
    regNo: "141/2004",
    department: "General Surgery",
    image: DrRishiImage, // ✅ d1
  },
  {
    sl: 2,
    name: "Dr. Priti Agrawal",
    designation: "Gynecologist",
    qualification: "MBBS MD MICCO FMAS FIMCH",
    council: "CGMC",
    regNo: "142/2004",
    department: "Gynecology",
    image: DrPritiImage, // ✅ d2
  },
  {
    sl: 3,
    name: "Dr. Chirag Agrawal",
    designation: "Senior Consultant & Interventional Cardiologist",
    qualification: "MBBS, MD (Medicine), DM (Cardiology)",
    department: "Cardiology",
    achievements: ["Gold Medallist", "9 Academic Distinctions"],
    experience: "Trained at premier central institute",
    hospitalExperience: "VMMC & Safdarjung Hospital, New Delhi",
    procedures: "Performed 5000+ successful cardiac procedures",
    expertise: "Extensive expertise and clinical experience in cardiology",
    image: DrChiragImage,
  },
  {
    sl: 4,
    name: "Dr. Deepak Agrawal",
    designation: "Orthopedics",
    qualification: "MBBS D.Ortho, H.P.O.",
    council: "CGMC",
    regNo: "641/2006",
    department: "Orthopedics",
    image: DrDeepakImage,

  },
  {
    sl: 5,
    name: "Dr. Pankaj Motghare",
    designation: "General Medicine",
    qualification: "MBBS MD",
    council: "CGMC",
    regNo: "1345/2008",
    department: "Medicine",
    image: DrPankajImage,
  },
  {
    sl: 6,
    name: "Dr. Rahul Kapoor",
    designation: "Urology",
    qualification: "MBBS MS, MCh (Urology)",
    council: "MMC",
    regNo: "2000010540",
    department: "Urologist",
    image: null,
  },
  {
    sl: 7,
    name: "Dr. Kunica Somani",
    designation: "ENT Surgeon",
    qualification: "MBBS MS ENT",
    council: "CGMC",
    regNo: "8798/2019",
    department: "ENT Surgeon",
    image: null,
  },
  {
    sl: 8,
    name: "Dr. Viplav Chatterjee",
    designation: "Radiologist",
    qualification: "MBBS MD DMRD, DNB",
    council: "CGMC",
    regNo: "5314/2014",
    department: "Radiologist",
    image: null,
  },
  {
    sl: 9,
    name: "Dr. Leena Bhuarya",
    designation: "Radiologist",
    qualification: "MBBS MD",
    council: "CGMC",
    regNo: "6105/2011",
    department: "Radiologist",
    image: null,
  },
  {
    sl: 10,
    name: "Dr. Hrishabh Jaiswal",
    designation: "Ophthalmologist",
    qualification: "MBBS MS FCO.FOO",
    council: "CGMC",
    regNo: "7970/2018",
    department: "Ophthalmology / Surgeon",
    image: null,
  },
  {
    sl: 11,
    name: "Dr. N. S. Garad",
    designation: "Gastroenterologist",
    qualification: "MBBS DNB Gastro",
    council: "CGMC",
    regNo: "11207/2021",
    department: "Gastroenterology",
    image: null,
  },
  {
    sl: 12,
    name: "Dr. Saumitra Singh",
    designation: "Pediatrician",
    qualification: "MBBS DCH, DNB",
    council: "CGMC",
    regNo: "6474/2016",
    department: "Paediatrics",
    image: null,
  },
  {
    sl: 13,
    name: "Dr. Ravi Rajendra Jaiswal",
    designation: "Medical Oncology",
    qualification: "MBBS, DCH, DNB",
    council: "CGMC",
    regNo: "11404/2021",
    department: "Medical Oncology",
    image: null,
  },
  {
    sl: 14,
    name: "Dr. Abhay Agrawal",
    designation: "Plastic Surgeon",
    qualification: "MBBS MCh Plastic Surgery",
    council: "CGMC",
    regNo: "8755/2019",
    department: "Surgeon",
    image: null,
  },
  {
    sl: 15,
    name: "Dr. Jagdish Uraiya",
    designation: "Orthopedics",
    qualification: "MBBS D.Ortho",
    council: "CGMC",
    regNo: "10023/2020",
    department: "Orthopedics",
    image: null,
  },
  {
    sl: 16,
    name: "Dr. Harshit Goenka",
    designation: "Orthopedics",
    qualification: "MBBS D.Ortho",
    council: "CGMC",
    regNo: "5717/2014",
    department: "Orthopedics",
    image: null,
  },
  {
    sl: 17,
    name: "Dr. Bharat Agrawal",
    designation: "Cardiologist",
    qualification: "MBBS MD DM (Cardio)",
    council: "CGMC",
    regNo: "10292/2013",
    department: "Cardiology",
    image: null,
  },
  {
    sl: 18,
    name: "Dr. Gaurav Ahluwalia",
    designation: "ENT Surgeon",
    qualification: "MBBS DLO ENT",
    council: "CGMC",
    regNo: "2228/2009",
    department: "ENT Surgeon",
    image: null,
  },
  {
    sl: 19,
    name: "Dr. Chandramukesh Dhawade",
    designation: "Neurology",
    qualification: "MBBS MS MCh",
    council: "CGMC",
    regNo: "2819/2010",
    department: "Neurosurgeon",
    image: null,
  },
  {
    sl: 20,
    name: "Dr. Sanjeev Tiwari",
    designation: "Pathologist",
    qualification: "MBBS MD Pathology",
    council: "CGMC",
    regNo: "4496/2012",
    department: "Pathologist",
    image: null,
  },
  {
    sl: 21,
    name: "Dr. Ajit Mishra",
    designation: "Gastroenterology",
    qualification: "MBBS MS MCh",
    council: "CGMC",
    regNo: "",
    department: "Gastroenterology",
    image: null,
  },
  {
    sl: 22,
    name: "Dr. Kedar Nath Dewangan",
    designation: "Medicine",
    qualification: "MBBS, MD (Chest Medicine)",
    council: "CGMC",
    regNo: "8329/2018",
    department: "Medicine",
    image: null,
  },
  {
    sl: 23,
    name: "Dr. Gagandeep Singh Saluja",
    designation: "Radiologist",
    qualification: "MBBS MD (RD – Diagnosis)",
    council: "CGMC",
    regNo: "6419/2015",
    department: "Radiologist",
    image: null,
  },
  {
    sl: 24,
    name: "Dr. Abhishek Singh",
    designation: "Anesthesist & Intensivist",
    qualification: "MBBS MD",
    council: "CGMC",
    regNo: "10635/2020",
    department: "ICU",
    image: null,
  },
  {
    sl: 25,
    name: "Dr. Jyotirmay Chandrakar",
    designation: "Anesthesist",
    qualification: "MBBS MD (Anaesthesia)",
    council: "CGMC",
    regNo: "4365/2012",
    department: "Anaesthesia",
    image: null,
  },
  {
    sl: 26,
    name: "Dr. Shankar Agrawal",
    designation: "Anesthesist",
    qualification: "MBBS MD",
    council: "CGMC",
    regNo: "8800/2019",
    department: "Anaesthesia",
    image: null,
  },
  {
    sl: 27,
    name: "Dr. Vikas Agrawal",
    designation: "Oncologist",
    qualification: "MBBS DNB (Onco Surgery)",
    council: "CGMC",
    regNo: "4571/2013",
    department: "Oncologist",
    image: null,
  },
  {
    sl: 28,
    name: "Dr. Krishna Somnani",
    designation: "Nephrologist",
    qualification: "MBBS MD, DM",
    council: "CGMC",
    regNo: "2957/2010",
    department: "Nephrologist",
    image: null,
  },
  {
    sl: 29,
    name: "Dr. Shristi Sharan",
    designation: "Dentist",
    qualification: "BDS",
    council: "CGDC",
    regNo: "G/22/3805",
    department: "Dentists",
    image: null,
  },
  {
    sl: 30,
    name: "Smita Sahu",
    designation: "Physiotherapy",
    qualification: "BPT",
    council: "CGPBOC",
    regNo: "400",
    department: "Physiotherapy",
    image: null,
  },
  {
    sl: 31,
    name: "Dr. B.K. Aakansha",
    designation: "Anesthesist & Intensivist",
    qualification: "MBBS, MD",
    council: "CGMC",
    regNo: "16507/2023",
    department: "ICU",
    image: null,
  },
  {
    sl: 32,
    name: "Dr. Rajesh Kumar",
    designation: "Pediatric Surgeon",
    qualification: "MBBS MS MCh",
    council: "CGMC",
    regNo: "XXXX/XXXX",
    department: "Paediatrics",
    image: null,
  },
  {
    sl: 33,
    name: "Dr. Priya Sharma",
    designation: "Dermatologist",
    qualification: "MBBS MD Dermatology",
    council: "CGMC",
    regNo: "YYYY/YYYY",
    department: "Dermatology",
    image: null,
  },
];